export default function() {
  $(document).ready(function() {

    var $flash_message = $('<div id="' + thinkwell.config.flash_message_id + '"></div>');
    $flash_message.css('position', 'absolute');
    $flash_message.css('top', '0');
    $flash_message.css('left', '0');
    $flash_message.css('width', '100%');
    $flash_message.css('height', '80px');
    $flash_message.css('background-color', '#f1813c');
    $flash_message.css('opacity', '.9');
    $flash_message.css('z-index', 3);
    $flash_message.css('display', 'none');
    $flash_message.css('color', '#efefef');
    $flash_message.css('font-size', '16px');
    $flash_message.css('font-weight', '600');
    $flash_message.css('text-align', 'center');
    $flash_message.css('padding-top', '26px');


    $('body').append($flash_message);

    window.thinkwell.$tw_flash_message = $flash_message;
  });
}
